import styles from './MiscLinksGrid.scss';

import cx from 'classnames';
import React from 'react';

import { Link } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Entries } from 'src/api/contentful/utilTypes';
import { componentKey, getField, getSys } from 'src/utils/EntryUtil';

import { useSalesChannel } from 'src/components/SalesChannel/SalesChannel';
import { Environment } from 'src/utils/Environment';
import { MiscListItem } from '../MiscListItem/MiscListItem';

const TD_BANK_EXCLUDED_LINK_IDS = [
  '2KLEkM6ZycqZgpsq6vziHJ', // Virtual Terminal
  '70bIA5YgmGRGx6IGPnKctB', // Financial Solutions
];

export interface IMiscLinksGrid extends React.AllHTMLAttributes<HTMLDivElement> {
  entries?: Entries<Link>;
  active?: boolean;
  singleCol?: boolean;
}

export const MiscLinksGrid: React.FC<IMiscLinksGrid> = ({
  entries = [] , active, singleCol, className, ...props
}) => {
  if (entries.length < 1) return null;

  return (
    <div className={cx(className, styles.gridWrapper)} {...props}>
      <ul
        className={cx(styles.miscLinksGrid, {
          [styles.miscLinksGridSingleCol]: singleCol,
        })}
      >
        {entries.map((entry, index) => {

          const contentfulId = getSys(entry, 'id');
          const { salesChannel, isDisallowedByReseller } = useSalesChannel();

          if (isDisallowedByReseller(entry)) {
            return null;
          }

          if (Environment.isTdReseller(getField(salesChannel, 'referralId'))
            && TD_BANK_EXCLUDED_LINK_IDS.includes(contentfulId || '')) {
            return null;
          }

          return (
            <MiscListItem
              className={styles.item}
              key={componentKey(entry, index)}
              active={active}
              button={index === entries.length - 1 && !!singleCol}
              entry={entry}
            />
          );
        })}
      </ul>
    </div>
  );
};
